import { createListenerMiddleware } from '@reduxjs/toolkit';
import {
    setComponents,
    setComponentState,
    runQuery,
    updateQueryState,
    sendEvent,
} from '@appblocks/frontend/redux/pageAppSlice';
import { evaluateStateExpression, getPageContext } from '@appblocks/frontend/cloudclient/AppEditor/components/utils';
import { axiosInstance } from '@appblocks/frontend/client/utils';

let pageContextUpdateDebounce = null;

const pageAppMiddleware = createListenerMiddleware();

const doUpdate = async (store) => {
    const { pageApp } = store.getState();
    const { components } = pageApp;
    for (let i = 0; i < components.length; i++) {
        const component = components[i];
        const keys = Object.keys(component.properties);
        for (let j = 0; j < keys.length; j++) {
            const key = keys[j];
            const propertyValue = component.properties[key];
            let newValue = propertyValue;
            // eslint-disable-next-line no-await-in-loop
            newValue = await evaluateStateExpression(pageApp, propertyValue);
            if (typeof newValue === 'string') {
                if (newValue === component.state[key]) {
                    continue;
                }
            } else if (JSON.stringify(newValue) === JSON.stringify(component.state[key])) {
                continue;
            }
            store.dispatch({
                type: 'pageApp/setComponentState',
                payload: {
                    componentId: component.id,
                    stateId: key,
                    value: newValue,
                },
            });
        }
    }
    doPageContextUpdateDebounce(store);
};

const doPageContextUpdateDebounce = async (store) => {
    if (pageContextUpdateDebounce) {
        clearTimeout(pageContextUpdateDebounce);
    }
    pageContextUpdateDebounce = setTimeout(async () => {
        await doPageContextUpdate(store);
    }, 30);
};

const doPageContextUpdate = async (store) => {
    const { pageApp } = store.getState();
    const newPageContext = await getPageContext(pageApp);
    store.dispatch({
        type: 'pageApp/setPageContext',
        payload: newPageContext,
    });
};

const processEvent = async (action, store) => {
    const { type, data, componentId } = action.payload;
    const component = store.getState().pageApp.components.find(c => c.id === componentId);
    if (!component) {
        return;
    }
    const actions = component.events[type];
    if (!actions) {
        return;
    }
    for (let i = 0; i < actions.length; i++) {
        const eventAction = actions[i];
        switch (eventAction.type) {
            case 'query':
                {
                    const queries = store.getState().pageApp.queries;
                    const query = queries.find(q => q.id === eventAction.data);
                    store.dispatch({
                        type: 'pageApp/runQuery',
                        payload: {
                            queryId: eventAction.data,
                            parameters: query.parameters,
                        },
                    });
                }
                break;
            case 'alert':
                console.log('processEvent', data);
                break;
            default:

                break;
        }
    }
};

pageAppMiddleware.startListening({
    actionCreator: setComponents,
    effect: async (action, store) => {
        doUpdate(store);
    },
});

pageAppMiddleware.startListening({
    actionCreator: setComponentState,
    effect: async (action, store) => {
        doUpdate(store);
    },
});

pageAppMiddleware.startListening({
    actionCreator: runQuery,
    effect: async (action, store) => {
        const { pageApp } = store.getState();
        const { app, queries } = pageApp;
        const pageId = app._id;
        const query = queries.find(q => q.id === action.payload.queryId);
        const parameters = action.payload.parameters || query.parameters;
        const params = {};
        const keys = Object.keys(parameters);
        for (let i = 0; i < keys.length; i++) {
            const key = keys[i];
            const value = parameters[key];
            params[key] = value;
            // eslint-disable-next-line no-await-in-loop
            params[key] = await evaluateStateExpression(pageApp, value);
        }

        try {
            const res = await axiosInstance.post(`${process.env.API_URL}/cgg/pages/${pageId}/query/${query.id}`, {
                parameters: params,
            });
            store.dispatch({
                type: 'pageApp/updateQueryState',
                payload: {
                    queryId: query.id,
                    data: {
                        loading: false,
                        error: res.data.error,
                        data: res.data.data,
                    },
                    error: undefined,
                },
            });
        } catch (err) {
            store.dispatch({
                type: 'pageApp/updateQueryState',
                payload: {
                    queryId: query.id,
                    data: {
                        loading: false,
                        error: err.message,
                        data: undefined,
                    },
                },
            });
        }
    },
});

pageAppMiddleware.startListening({
    actionCreator: updateQueryState,
    effect: async (action, store) => {
        doUpdate(store);
    },
});

pageAppMiddleware.startListening({
    actionCreator: sendEvent,
    effect: async (action, store) => {
        processEvent(action, store);
    },
});


export default pageAppMiddleware;
